module.exports = __webpack_public_path__ + "img/bg-404.20709727.svg";